import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseFindByKeyPipeModule } from '../../@fuse/pipes/find-by-key';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { FuseAlertModule } from '../../@fuse/components/alert';
import { RouterModule } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { TableComponent } from './components/table/table.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { getEsPaginatorIntl } from './components/paginator/es-paginator-intl';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GetDownloadURLPipeModule } from '@angular/fire/compat/storage';
import { MatCardModule } from '@angular/material/card';
import { MAT_MOMENT_DATE_FORMATS, MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { MatSelectModule } from '@angular/material/select';
import { FuseCardModule } from '../../@fuse/components/card';
import { MatIconModule } from '@angular/material/icon';
import { FormlyModule } from '@ngx-formly/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRadioModule } from '@angular/material/radio';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslocoModule } from '@ngneat/transloco';
import { MatDividerModule } from '@angular/material/divider';
import { FileValueAccessor } from './components/file-type/file-value.accesor';
import { FormlyFieldFileComponent } from './components/file-type/file-type.component';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FuseConfirmationModule } from '../../@fuse/services/confirmation';
import { CalendarModule } from 'angular-calendar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FuseDrawerModule } from '../../@fuse/components/drawer';
import { CalendarHeaderComponent } from './components/calendar-header/calendar-header.component';
import { MomentTimestampDatePipe } from './pipes/moment-timestamp-date.pipe';
import { AvatarPhotoComponent } from './components/avatar-photo/avatar-photo.component';
import { ColorTwitterModule } from 'ngx-color/twitter';
import { QuillModule } from 'ngx-quill';
import { MatTreeModule } from '@angular/material/tree';
import { MatExpansionModule } from '@angular/material/expansion';
import { FuseScrollbarModule } from '../../@fuse/directives/scrollbar';
import { PrintableHeaderComponent } from './components/printable-header/printable-header.component';
import { SignModalComponent } from './components/sign-modal/sign-modal.component';
import { AutocompleteTypeComponent } from './components/autocomplete-type/autocomplete-type.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
  FormFieldClientSelectComponent
} from './components/form-field-client-select/form-field-client-select.component';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MatTimepickerModule } from 'mat-timepicker';
import { LoadingComponent } from './components/loading/loading.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { MatChipsModule } from '@angular/material/chips';
import { ClientFinderComponent } from './components/client-finder/client-finder.component';
import { PDFViewerComponent } from './components/pdfviewer/pdfviewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatBadgeModule } from '@angular/material/badge';
import { BoardAddCardComponent } from './components/board-add-card/board-add-card.component';
import { UserComponent } from './components/user/user.component';
import {
  AgendaService,
  DayService,
  DragAndDropService,
  MonthService,
  ResizeService,
  ScheduleAllModule,
  ScheduleModule,
  WeekService,
  WorkWeekService
} from '@syncfusion/ej2-angular-schedule';
import { ButtonAllModule, ButtonModule, CheckBoxAllModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';

const modules: any[] = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  TranslocoModule,
  FormlyModule,
  FormlyMatDatepickerModule,
  FormlyMatToggleModule,
  GetDownloadURLPipeModule,
  NgApexchartsModule,
  CalendarModule,
  ColorTwitterModule,
  QuillModule.forRoot(),
  NgxDocViewerModule,
  MatTimepickerModule,
  PdfViewerModule,
  NgOptimizedImage
];

const materialModules: any[] = [
  MatButtonModule,
  MatDividerModule,
  MatFormFieldModule,
  MatMenuModule,
  MatTooltipModule,
  MatIconModule,
  MatInputModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatTableModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatTabsModule,
  MatMomentDateModule,
  MatPaginatorModule,
  DragDropModule,
  MatSortModule,
  MatCardModule,
  MatProgressBarModule,
  MatDialogModule,
  MatButtonToggleModule,
  MatRippleModule,
  MatTreeModule,
  MatExpansionModule,
  MatAutocompleteModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatBadgeModule
];

const fuseModules: any[] = [
  FuseCardModule,
  FuseAlertModule,
  FuseFindByKeyPipeModule,
  FuseConfirmationModule,
  FuseDrawerModule,
  FuseScrollbarModule
];

const ejsModules: any[] = [
  ScheduleModule, ScheduleAllModule, CheckBoxModule, CheckBoxAllModule, ButtonModule, ButtonAllModule
];

const components: any[] = [
  UserComponent,
  TableComponent,
  FileValueAccessor,
  FormlyFieldFileComponent,
  CalendarHeaderComponent,
  AvatarPhotoComponent,
  AutocompleteTypeComponent,
  PrintableHeaderComponent,
  SignModalComponent,
  FormFieldClientSelectComponent,
  LoadingComponent,
  ClientFinderComponent,
  PDFViewerComponent,
  BoardAddCardComponent
];

const directives: any[] = [
  DragAndDropDirective
];

const pipes: any[] = [
  EllipsisPipe,
  MomentTimestampDatePipe
];


@NgModule({
  imports: [
    ...modules,
    ...materialModules,
    ...fuseModules,
    ...ejsModules
  ],
  exports: [
    ...components,
    ...directives,
    ...pipes,
    ...modules,
    ...materialModules,
    ...fuseModules,
    ...ejsModules
  ],
  declarations: [
    ...components,
    ...directives,
    ...pipes
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [ MAT_DATE_LOCALE ] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MatPaginatorIntl, useValue: getEsPaginatorIntl() },
    {
      provide: LOCALE_ID,
      useValue: 'es-ES'
    },
    AgendaService, DayService, MonthService, WeekService, WorkWeekService, ResizeService, DragAndDropService
  ]
})
export class SharedModule {
}


